import React from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderTwo from "../../components/HeaderTwo";
import Breadcrumb from "../../components/Breadcrumb";
import FooterTwo from "../../components/FooterTwo";
import BottomFooter from "../../components/BottomFooter";
import UserGaurd from "../../helper/AuthGaurd";
import DashboardSidebar from "../../components/DashboardSidebar";

const Dashboard = () => {
  return (
    <UserGaurd>
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Dashboard"} />
      <div className="container container-lg d-flex gap-4">
        <DashboardSidebar />
        <main></main>
      </div>

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </UserGaurd>
  );
};

export default Dashboard;
